import { handleSendYandexMetrika } from './main';
import { curry } from '../curry';

const curriedHandleSendYandexMetrika = curry(handleSendYandexMetrika);

const sendYandexMetrika = curriedHandleSendYandexMetrika(26001372, 'reachGoal');

/** Успешное отключение Яндекс Плюс */
const yandexPlusDisconnectedSuccessYM = () => {
  sendYandexMetrika(
    'ServiceDisconnectSuccess',
    {
      ServiceDisconnect: {
        'Яндекс Плюс: https': '//moskva.beeline.ru/customers/products/mobile/profile/#/services',
      },
    },
  );
};

/** Успешная активация Яндекс Плюс after 27.04 */
const yandexPlusConnectedYMUpd = (service, connectedService) => {
  sendYandexMetrika(
    'ServiceConnectSuccess',
    { service_ev_: {
      service_connect: {
        [service]: connectedService,
      },
    } },
  );
};

/** Успешное отключение Яндекс Плюс after 27.04 */
const yandexPlusDisconnectedSuccessYMUpd = (service, connectedService) => {
  sendYandexMetrika(
    'ServiceDisconnectSuccess',
    { service_ev_: {
      service_connect: {
        [service]: connectedService,
      },
    } },
  );
};

export { yandexPlusDisconnectedSuccessYM, yandexPlusConnectedYMUpd, yandexPlusDisconnectedSuccessYMUpd };
